import { notFound } from '@tanstack/react-router';

/**
 * Parses a bigint path segment (org, PDS version, questionnaire, register IDs and so on).
 *
 * A non-numeric segment such as `/public/lodgement/55` matching `/public/$orgId` is a
 * 404, not a `BigInt` SyntaxError or Zod invalid_type error for Sentry (CURIUM-FE-V9).
 */
export function parseBigintRouteParam(value: string): bigint {
    if (!/^\d+$/.test(value)) {
        throw notFound();
    }

    return BigInt(value);
}
